/**
 * When the anchor matches one of these subdomains, don't open in iframe.
 */
const subdomainsToIgnore = ['api', 'auth', 'dashboard'] as const;

const shouldIgnoreUrl = (url: string, domain: string): boolean => {
    const regexDomain = domain.replace(/\./g, '\\.');

    // Extract just the domain part from the URL (ignore path)
    const urlDomain = url.replace(/^https?:\/\//, '').split('/')[0];

    // If no domain part found, ignore the URL
    if (!urlDomain) {
        return true;
    }

    // First check if it's NOT from the specified domain at all
    if (!new RegExp(`${regexDomain}$`).test(urlDomain)) {
        return true;
    }

    // Then check if it's one of the blocked subdomains
    const blockedSubdomainRegex = new RegExp(
        `^(${subdomainsToIgnore.join('|')})${regexDomain}$`
    );

    return blockedSubdomainRegex.test(urlDomain);
};

export default shouldIgnoreUrl;
